import { render, staticRenderFns } from "./StorageInformation.vue?vue&type=template&id=2dbbbaeb&"
import script from "./StorageInformation.vue?vue&type=script&lang=js&"
export * from "./StorageInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports